module.exports = __webpack_public_path__ + "static/media/scLogo.747575b2.png";